import { getBrandById, type BrandConfig } from "@callcenterai/brand";

/**
 * Feature 294 — the brand of this kitchen display, stated at build by
 * VITE_BRAND_ID (see vite.config.ts). Read its fields, never compare its id.
 */
export const brand: BrandConfig = getBrandById(import.meta.env.VITE_BRAND_ID);
